import React from "react";
import {useSelector} from "react-redux";
import RootState from "../../../redux/states/root.state";
import { ManualIcon } from "../../../assets/svg/svg";

const SpaManualCard: React.FC = () => {
    const {spasWithSbHours} = useSelector((state: RootState) => state.dashboard);
    const length = spasWithSbHours?.spa_guids?.length??0;

  return (
    <div className="kpi-card" id="manual-mode">
      <div className="kpi-head">
        <span className="kpi-icon"><ManualIcon/></span>
        <span className="kpi-title">Manual Mode</span>
      </div>
      <div className="kpi-body">
        <strong className="kpi-value">{length}</strong>
        <span className="kpi-unit">{length===1?'spa':'spas'}</span>
      </div>
      <span className="kpi-caption">Currently in manual mode</span>
    </div>
);
};

export default SpaManualCard;
